import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EmopItemClass } from '../../../app/class/EmopItemClass/EmopItemClass';

@Component({
  selector: 'emop-item',
  templateUrl: './emop-item.component.html',
  styleUrls: ['./emop-item.component.scss']
})
export class EmopItemComponent implements OnInit {
  tempData: EmopItemClass;
  passwordVisible: boolean = false;
  @Input() data: EmopItemClass;

  constructor() { }

  ngOnChanges({ data }): void {
  }
  ngOnInit(): void {
  }
  // 监听输入事件
  onChangeFn(value) {
    this.data.value = value;
    this.data.onChange && this.data.onChange(this.data);
  }
  onBlurFn() {
    this.data.onBlur && this.data.onBlur(this.data);
  }
  onClickFn() {
    this.data.onClick && this.data.onClick(this.data);
  }
  onEnterFn() {
    this.data.onEnter && this.data.onEnter(this.data);
  }
  onOpenFn(data, isOpen) {
    this.data.onOpen && this.data.onOpen({
      data,
      isOpen
    });
  }
}
